export default __webpack_public_path__ + "static/media/3.ac45235f.jpg";